import { __decorate, __metadata, __param } from "tslib";
import { smoothScroll } from '@gn-audio/ui/tools/smooth-srcoll';
import { Directive, Inject, Input } from 'angular-ts-decorators';
import { isElementHidden, isMobile } from '../utils';
var ScrollToOnClickDirective = (function () {
    function ScrollToOnClickDirective($element) {
        this.$element = $element;
    }
    ScrollToOnClickDirective.prototype.ngOnInit = function () {
        this.$element.on('click', this.scrollToHandler.bind(this));
    };
    ScrollToOnClickDirective.prototype.ngOnDestroy = function () {
        this.$element.off('click', this.scrollToHandler);
    };
    ScrollToOnClickDirective.prototype.scrollToHandler = function () {
        var target = document.querySelector(this.scrollToSelector);
        if (target === null || isElementHidden(target) || this.isScrollDenied()) {
            return;
        }
        smoothScroll(target);
    };
    ScrollToOnClickDirective.prototype.isScrollDenied = function () {
        return this.scrollToExcludeDesktop && !isMobile();
    };
    ScrollToOnClickDirective.$inject = ['$element'];
    __decorate([
        Input('@'),
        __metadata("design:type", String)
    ], ScrollToOnClickDirective.prototype, "scrollToSelector", void 0);
    __decorate([
        Input('@'),
        __metadata("design:type", Boolean)
    ], ScrollToOnClickDirective.prototype, "scrollToExcludeDesktop", void 0);
    ScrollToOnClickDirective = __decorate([
        Directive({
            selector: '[scrollToOnClick]',
        }),
        __param(0, Inject('$element')),
        __metadata("design:paramtypes", [Object])
    ], ScrollToOnClickDirective);
    return ScrollToOnClickDirective;
}());
export { ScrollToOnClickDirective };
